import { request } from '@/api/request';
import { encrypt } from '@/utils/crypto';

/**
 * Get account by ID
 * @param id Account ID
 * @returns Promise
 */
export function getAccountById(id: number): Promise<any> {
  return request({
    url: `/id-enterprise/api/account-info/${id}`,
    method: 'GET'
  });
}

/**
 * Delete account
 * @param id Account ID
 * @returns Promise
 */
export function deleteAccount(id: number): Promise<any> {
  return request({
    url: `/id-enterprise/api/account-info/${id}`,
    method: 'DELETE'
  });
}

/**
 * Request email change
 * @param params New email parameters
 * @returns Promise
 */
export function requestEmailChange(params: Account.EmailChangeParams): Promise<any> {
  return request({
    url: '/rs-enterprise/api/v1/account/email-change/request',
    method: 'POST',
    data: params
  });
}

/**
 * Get account list
 * @param params Account list query parameters
 * @returns Promise
 */
export function getAccountList(params: Account.GetListParams): Promise<any> {
  return request({
    url: '/id-enterprise/api/account-info/account-center-list',
    method: 'POST',
    data: params
  });
}
export function changePassword(params: Account.ChangePasswordParams): Promise<any> {
  const p = {
    oldPassword:  encrypt(params.oldPassword),
    newPassword:  encrypt(params.newPassword),
    confirmPassword:  encrypt(params.confirmPassword),
  }
  return request({
    url: '/rs-enterprise/api/v1/account/change-password',
    method: 'POST',
    data: p
  });
}

/**
 * Check if email exists
 * @param email Email to check
 * @returns Promise - Returns an object with status and description
 */
export interface EmailCheckResult {
  status: number; // 0-不存在，1-已存在（当前企业），2-已存在于其他企业
  description: string;
}

export function checkEmailExists(email: string): Promise<EmailCheckResult> {
  return request({
    url: '/id-enterprise/api/account-info/check-email',
    method: 'POST',
    data: { email }
  });
}

/**
 * Get role list for super admin
 * @returns Promise
 */
export function getRoleListForSuperAdmin(): Promise<any> {
  return request({
    url: '/id-enterprise/api/account-info/roles/super-admin',
    method: 'GET'
  });
}

/**
 * Save account (create or update)
 * @param params Account save parameters
 * @returns Promise
 */
export interface SaveAccountParams {
  id: number;
  name: string;
  email: string;
  position: string;
  productRoleRelations: {
    productId: number;
    roleId: number;
  }[];
}

export function saveAccount(params: SaveAccountParams): Promise<any> {
  return request({
    url: '/id-enterprise/api/account-info/save-account-super-admin',
    method: 'POST',
    data: params
  });
}

/**
 * Get last used product
 * @returns Promise containing the last used product ID
 */
export function getLastUsedProduct(): Promise<number> {
  return request({
    url: '/id-enterprise/api/account-info/last-used-product',
    method: 'GET'
  });
}

/**
 * Report login product
 * @param params Object containing the product ID to report
 * @returns Promise
 */
export interface ReportLoginProductParams {
  productId: number;
}

export function reportLoginProduct(params: ReportLoginProductParams): Promise<void> {
  return request({
    url: '/id-enterprise/api/account-info/report-login-product',
    method: 'POST',
    data: params
  });
}

